// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Zr3CR","validationTips":"StatementDescriptor_validationTips__3Sbj9"};